import { apiRequest } from "api-client";
import apiEndpoints from "constants/endpoints";
import {
  GET_SPORTS_ERROR,
  GET_SPORTS_FINISH,
  GET_SPORTS_START,
} from "store/actionTypes/sport";

export const getSports = () => {
  return (dispatch) => {
    dispatch({
      type: GET_SPORTS_START,
    });
    apiRequest
      .get(`${apiEndpoints.sports}`)
      .then((data) => {
        dispatch({
          type: GET_SPORTS_FINISH,
          payload: data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_SPORTS_ERROR,
          payload: err,
        });
      });
  };
};
